<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="物料编码">
              <el-input v-model="q.materialCode" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="销售公司" class="h-elformWrap-2">
              <brselect placeholder="请选择"
                        category="xsyb_gongsi"
                        :v="q.gscode"
                        clearable
                        v-model="q.gscode">
              </brselect>
            </el-form-item>
            <el-form-item label="产地" class="h-elformWrap-2" prop="factory">
              <brselect category="factory"  :v="q.factory" clearable v-model="q.factory"/>
            </el-form-item>
          </div>
        </el-form>
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="queryPage">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
          </div>
        </div>
      </div>
      <div class="h-table h-mrt30">
        <el-table
                ref="ddtable"
                :data="tableData"
                stripe
                border
                style="width: 100%">
          <el-table-column
                  type="index"
                  width="40"
                  label="序号"
                  fixed >
          </el-table-column>
          <el-table-column
                  prop="materialCode"
                  label="物料编码"
                  :show-overflow-tooltip="true"
                  width="120">
          </el-table-column>

          <el-table-column
                  prop="materialName"
                  label="物料名称"
                  show-overflow-tooltip
                  width="200">
          </el-table-column>

          <el-table-column
                  prop="gscode"
                  label="销售公司"
                  :show-overflow-tooltip="true"
                  width="120">
          </el-table-column>
          <el-table-column
                  prop="factory"
                  label="产地"
                  :show-overflow-tooltip="true"
                  width="120">
          </el-table-column>
          <el-table-column
                  prop="unitPrice"
                  label="公司间采购价"
                  :show-overflow-tooltip="true"
                  width="120">
          </el-table-column>

          <el-table-column
                  prop="effectiveDate"
                  label="有效日期"
                  :formatter="formatDatecc"
                  width="110">
          </el-table-column>
          <el-table-column
                  prop="status"
                  label="价格状态"
                  width="110">
            <template scope="scope">
              {{scope.row.status|dictname('bsc_order_salse_price')}}
            </template>
          </el-table-column>
          <el-table-column
                  prop="cuname"
                  label="创建人名称"
                  width="110">
          </el-table-column>

          <el-table-column
                  prop="cdate"
                  label="创建时间"
                  :formatter="formatDatecc"
                  width="110">
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-pagination2">
            <pagination :page="q" @query="queryPage" />
          </div>
        </div>
      </div>
      <div class="bannerBox2" v-if="0 == $route.query.taskstatus">
        <div class="h-row">
          <div class="h-rowIn">
            <div class="h-rowBox">
              <div class="h-rowCon">
                <div class="h-pieceIn2">
                  <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                    <h1>审核信息</h1>
                  </div>
                  <div class="h-pieceCon2 ">
                    <div class="h-formLine weekplandetail11" style="position: relative;">
                      <el-form :inline="true" :model="shenPiAgent">
                        <el-form-item label="审批意见" class="h-elformWrap-2 newBox"
                                      style="width: 100%!important;">
                          <el-input
                              v-model="shenPiAgent.auditMind2"
                              placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align: center;margin-top: 0.3rem">
        <el-button class="h-btn h-bBtn h-bgred"
                   @click="shenPiAgentPass(1)" v-if="0 == $route.query.taskstatus">驳回
        </el-button>
        <el-button class="h-btn h-bBtn h-bggreen" v-if="0 == $route.query.taskstatus" @click="shenPiAgentPass(1)">
          通过
        </el-button>
        <el-button class="h-btn h-bBtn" @click="viewpress">
          审批跟踪
        </el-button>
      </div>
    </div>
    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
  </div>
</template>
<script>

import cgOrderPrice from "../../../api/price/cgOrderPrice.js";
import ss from "../../../api/SystemService";

export default {
  components: {},
  data() {
    return {
      tableData:[],
      shenPiAgent:{
        msg:"",
        taskid:this.$route.query.taskid,
        instId:this.$route.query.instid,
        aaa:null,
      },
      showhistory:false,
      instid:null,
      q:{
        //物料编码
        materialCode:null,
        //产品大类
        prodseries:null,
        //客户编码
        customerCode:null,
        //国际条款
        gjmytk:null,
        //流程id
        instId:this.$route.query.instid,
        delflag:1,
        pageSize:10,
        pageNo:1,
        total:0,
      },
    }
  },
  created() {
    this.instid = this.$route.query.instid;
    console.log(this.instid)
    this.queryPage();
  },
  methods: {
    /**
     * 查询
     */
    queryPage() {
      ss.cgOrderPrice.selecPage(this.q).then(res => {
        this.q.total = res.total;
        this.tableData = res.records;
      })
    },
    /**
     * 凭证过账日期格式化
     * @param row
     * @param column
     * @returns {string|null}
     */
    formatDatecc(row, column) {
      // 获取单元格数据
      let data = row[column.property]
      if(data == null || data == '') {
        return null
      }
      let dt = new Date(data)
      return this.$util.riQi3(dt);
    },
    /**
     * 重置查询
     */
    resetData(){
      var pageSize=this.q.pageSize;
      var pageNo=this.q.pageNo;
      var total=this.q.total;
      this.q= {
        //物料编码
        materialCode:null,
        //产品大类
        prodseries:null,
        instId:this.$route.query.instid,
        gjmytk:null,
        delflag:1,
        customerCode:null,
        pageSize: pageSize,
        pageNo: pageNo,
        total:total,
      }
      this.queryPage();
    },
    viewpress() {
      this.showhistory = true;
    },
    shenPiAgentPass(result){
      this.shenPiAgent.aaa = result;
      ss.cgOrderPrice.shenPiAgentPass(this.shenPiAgent).then(res => {
        if (res.f){
          this.$msg.alerts("提交成功！", () => {
            //跳转回系统的代办列表
            this.$router.push({
              path: '/personal/dealCenter'
            })
          })
        }else {
          this.$msg.alerts("提交失败！", "提示")
        }
      })

    },
  }
}
</script>

<style>

</style>
<style scoped>

</style>